import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=3b30497e&scoped=true"
import script from "./Partnership.vue?vue&type=script&lang=js"
export * from "./Partnership.vue?vue&type=script&lang=js"
import style0 from "./Partnership.vue?vue&type=style&index=0&id=3b30497e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b30497e",
  null
  
)

export default component.exports